import { Edit, SimpleForm, TextInput, NumberInput } from 'react-admin';

export const CountryCpmEdit = () => (
  <Edit>
    <SimpleForm>
        <TextInput source="country_name" />
        <TextInput source="country_code" />
        <NumberInput source="cpm_floor_video" />
        <NumberInput source="rev_share_base_usd" />
        <NumberInput source="rev_share_boosted_usd" />
    </SimpleForm>
  </Edit>
);